import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const CAUSE = [
  {
    t: "Più canali di prenotazione non collegati tra loro",
    d: "Telefono, WhatsApp, email, Instagram: se ogni richiesta finisce su un calendario diverso (o su nessun calendario), prima o poi due persone prenotano lo stesso veicolo nello stesso giorno senza che nessuno se ne accorga fino al ritiro.",
  },
  {
    t: "Nessun buffer tra un noleggio e l'altro",
    d: "Anche con un solo calendario, se il veicolo torna alle 10 e riparte subito alle 10, non c'è margine per un controllo, un rifornimento o una pulizia. Un ritardo alla riconsegna diventa automaticamente un ritardo per il cliente successivo.",
  },
  {
    t: "Modifiche fatte a mano su fogli condivisi",
    d: "Un foglio Excel condiviso tra più operatori sembra una soluzione, ma se due persone lo modificano nello stesso momento, o uno lo aggiorna con ritardo dopo una chiamata, la versione che tutti vedono può non essere quella reale.",
  },
  {
    t: "Nessuna conferma automatica al cliente",
    d: "Se la conferma di una prenotazione dipende da un operatore che deve rispondere manualmente, in caso di alto volume (weekend, alta stagione) è facile che una richiesta resti sospesa e nel frattempo lo stesso veicolo venga proposto a qualcun altro.",
  },
];

const SOLUZIONI = [
  "Un solo calendario disponibilità, condiviso in tempo reale da tutti gli operatori e dal sito di prenotazione pubblico",
  "Blocco automatico del veicolo appena una prenotazione viene confermata, non a fine giornata",
  "Buffer configurabile tra una riconsegna e la prenotazione successiva",
  "Notifica immediata a tutti gli operatori quando arriva una nuova prenotazione, qualunque sia il canale",
];

const BC_ITEMS = [{ name: "Evitare le doppie prenotazioni", path: "/come-evitare-doppie-prenotazioni-autonoleggio" }];

export default function ComeEvitareDoppiePrenotazioni({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["come-evitare-doppie-prenotazioni-autonoleggio"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Guida</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Come evitare le <mark>doppie prenotazioni</mark>
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            L'overbooking su un veicolo a noleggio non è mai un caso: ha
            sempre una causa organizzativa precisa.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <h2 style={{ fontSize: "1.3rem", marginBottom: "1rem" }}>Da dove nasce il problema</h2>
          {CAUSE.map((c) => (
            <div key={c.t} className="an" style={{ marginBottom: "1.5rem" }}>
              <h3 style={{ fontSize: "1.05rem", marginBottom: ".35rem" }}>{c.t}</h3>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{c.d}</p>
            </div>
          ))}

          <h2 style={{ fontSize: "1.3rem", margin: "2.5rem 0 1rem" }}>Cosa la elimina alla radice</h2>
          <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 1.9, marginBottom: "2rem" }}>
            {SOLUZIONI.map((s) => (
              <li key={s} style={{ marginBottom: ".5rem" }}>{s}</li>
            ))}
          </ul>

          <div className="an" style={{ padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Come funziona il calendario di NoleggioinCloud
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              Ogni prenotazione, arrivi dal sito pubblico o inserita a mano
              dal pannello admin, blocca automaticamente il veicolo per il
              periodo scelto: non esiste un secondo calendario "ufficioso"
              da tenere allineato a parte.
            </p>
            <Link to="/funzionalita" style={{ fontWeight: 600 }}>
              Vedi la gestione calendario nel dettaglio →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "come-evitare-doppie-prenotazioni-autonoleggio").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
